<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import { useAlert } from 'dashboard/composables';
import LaisHeader from 'dashboard/components-next/LaisHeader.vue';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';
import RealEstateBrokerRequestValueCard from '../components/RealEstateBrokerRequestValueCard.vue';
import { useRealEstateBrokerCommissionRequest } from '../composables/useRealEstateBrokerCommissionRequest';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const installmentId = computed(() => route.params.installmentId);
const state = useRealEstateBrokerCommissionRequest({
  installmentId,
  notify: useAlert,
  t,
});

const accountParams = computed(() => ({ accountId: route.params.accountId }));
const goBack = () =>
  router.push({
    name: 'operacao_imobiliaria_corretor_parcela',
    params: { ...accountParams.value, installmentId: installmentId.value },
  });
const continueToDocument = async () => {
  const request = await state.confirm();
  if (!request) return;

  router.push({
    name: 'operacao_imobiliaria_corretor_nota',
    params: { ...accountParams.value, installmentId: installmentId.value },
  });
};
</script>

<template>
  <div class="min-h-full bg-lais-bg-soft">
    <LaisHeader
      :title="t('REAL_ESTATE_BROKER_COMMISSION.REQUEST.PAGE_TITLE')"
      :subtitle="t('REAL_ESTATE_BROKER_COMMISSION.REQUEST.PAGE_SUBTITLE')"
      :breadcrumb="[
        { label: t('REAL_ESTATE_BROKER_DASHBOARD.TITLE') },
        { label: t('REAL_ESTATE_BROKER_COMMISSION.REQUEST.PAGE_TITLE') },
      ]"
      show-back
      :back-label="t('REAL_ESTATE_BROKER_COMMISSION.ACTIONS.BACK')"
      @back="goBack"
    />
    <main
      class="mx-auto flex w-full max-w-[760px] flex-col gap-5 px-4 pb-8 sm:px-6 lg:px-10"
    >
      <div
        v-if="state.loading.value"
        class="h-96 animate-pulse rounded-lais bg-white"
      />
      <p
        v-else-if="state.error.value"
        class="rounded-lais border border-red-200 bg-red-50 p-3 text-sm text-red-700"
      >
        {{ state.error.value }}
      </p>
      <template v-else-if="state.detail.value">
        <RealEstateBrokerRequestValueCard
          :detail="state.detail.value"
          :agreed="state.agreed.value"
          :disabled="!state.detail.value.acoes?.pode_solicitar_transferencia"
          @update:agreed="state.agreed.value = $event"
        />
        <div class="flex flex-wrap justify-end gap-3">
          <LaisPrimaryButton variant="ghost" @click="goBack">
            {{ t('REAL_ESTATE_BROKER_COMMISSION.ACTIONS.BACK') }}
          </LaisPrimaryButton>
          <LaisPrimaryButton
            icon="i-lucide-arrow-right"
            :disabled="!state.canConfirm.value"
            :is-loading="state.saving.value"
            @click="continueToDocument"
          >
            {{ t('REAL_ESTATE_BROKER_COMMISSION.REQUEST.CONTINUE') }}
          </LaisPrimaryButton>
        </div>
      </template>
    </main>
  </div>
</template>
